export default {
      id: "hamburger-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "app/svg/sprite.svg#hamburger",
      toString: function () {
        return this.url;
      }
    }